import store from '@/store'
import { cloneDeep } from '@/plugins/cloneDeep'
import toastMaker from '@/utils/toast-maker'

export default service => {
  /**
   * Created
   */
  service.on('created', (result, context) => {
    // Add full dot to store
    console.log('toast', result)
    const { toast } = cloneDeep(result)
    store.commit('dots/add', cloneDeep(result))
    store.commit('dots/fresh', result.id)

    console.log(toast)
    // Send toast
    if (toast) {
      toastMaker.toast(toast, store)
    }
  })

  service.on('updated', (result, context) => {
    const { dot, provider, pages, browsers } = result
    store.commit('dots/add', {
      provider,
      pages,
      browsers
    })
  })
}
